import { render, staticRenderFns } from "./MatchSummary.vue?vue&type=template&id=2fef0c24&"
import script from "./MatchSummary.vue?vue&type=script&lang=js&"
export * from "./MatchSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports